import React, { useState, useContext } from 'react';
import { UserContext } from '../contexts/UserContext';
import { Typography, Grid, Paper, Avatar, Button } from '@mui/material';
import { auth } from '../api/client';

const avatarOptions = ['🐱', '🐶', '🐵', '🦊', '🐸', '🐼', '🐧', '🐢', '🐙', '🐝', '👾', '🤖'];

const ProfilePage = () => {
  const { user, setUserAvatar } = useContext(UserContext);
  const [selected, setSelected] = useState(user?.avatar || avatarOptions[0]);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await auth.setAvatar(selected);
      setUserAvatar(selected);  // ✅ updates both React state and localStorage
    } catch {
      // saving state reset below regardless
    }
    setSaving(false);
  };

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        🎨 Choose Your Avatar
      </Typography>

      <Grid container spacing={2}>
        {avatarOptions.map((icon) => (
          <Grid item key={icon}>
            <Paper
              elevation={selected === icon ? 6 : 1}
              sx={{
                padding: 2,
                textAlign: 'center',
                cursor: 'pointer',
                backgroundColor: selected === icon ? '#cce5ff' : 'inherit',
              }}
              onClick={() => setSelected(icon)}
            >
              <Avatar sx={{ width: 56, height: 56, fontSize: 32 }}>{icon}</Avatar>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Button
        variant="contained"
        color="primary"
        sx={{ mt: 3 }}
        onClick={handleSave}
        disabled={saving}
      >
        {saving ? 'Saving...' : 'Save Avatar'}
      </Button>
    </div>
  );
};

export default ProfilePage;
